import moment from "moment";

import { SessionExtra } from "../../store/Session/SessionModel";
import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";

import "./style.css";

interface Props {
  sessionData: SessionExtra;
}

const SessionLocation = ({ sessionData }: Props): JSX.Element => {
  return (
    <>
      <div className="location-time">
        <div className="location">
          {sessionData.address && (
            <img
              className="icon-location-pin"
              alt=""
              src="/img/fs_icon-locationpin.png"
            />
          )}
          <div className="place">
            <SkeletonLineWrapper width="200px">
              {sessionData.address}
            </SkeletonLineWrapper>
          </div>
        </div>
        <div className="date-time">
          <SkeletonLineWrapper>
            {moment.unix(sessionData.startTimestamp).format("MMM D, YYYY")}
          </SkeletonLineWrapper>
        </div>
      </div>
    </>
  );
};

export default SessionLocation;
